/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Domain as BoLankaContractDomain } from '../models/BoLanka/Contract/domain';

@Injectable({
  providedIn: 'root',
})
export class DomainService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiRoutesTrmIdDomainGet
   */
  static readonly ApiRoutesTrmIdDomainGetPath = '/api/routes/{trmId}/domain';

  /**
   * ### Claim
   *  boservice.routes.listdomainname
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoutesTrmIdDomainGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesTrmIdDomainGet$Response(params: {
    trmId: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<BoLankaContractDomain>>> {

    const rb = new RequestBuilder(this.rootUrl, DomainService.ApiRoutesTrmIdDomainGetPath, 'get');
    if (params) {
      rb.path('trmId', params.trmId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<BoLankaContractDomain>>;
      })
    );
  }

  /**
   * ### Claim
   *  boservice.routes.listdomainname
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoutesTrmIdDomainGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoutesTrmIdDomainGet(params: {
    trmId: number;
  },
  context?: HttpContext

): Observable<Array<BoLankaContractDomain>> {

    return this.apiRoutesTrmIdDomainGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<BoLankaContractDomain>>) => r.body as Array<BoLankaContractDomain>)
    );
  }

}
